import React, { Ref, useMemo } from "react";
import {
  SvgIconProps,
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps,
} from "@mui/material";
import { getIsEmptyString } from "utils/helpers";
import styles from "./TextField.styles";

export type TTextFieldProps = MuiTextFieldProps & {
  combobox?: boolean;
  multiline?: boolean;
  emptyLabel?: string;
  variant?: "outlined" | "standard" | "filled";
  iconSize?: SvgIconProps["fontSize"];
};

const TextField = React.forwardRef((props: TTextFieldProps, ref: Ref<any>) => {
  const { label, emptyLabel, ...textFieldProps } = props;

  const sx = {
    ...styles.textfield,
    ...props.sx,
  };

  const displayedLabel = useMemo(
    () =>
      textFieldProps.value || getIsEmptyString(emptyLabel) ? label : emptyLabel,
    [emptyLabel, textFieldProps.value, label],
  );

  return (
    <MuiTextField
      {...textFieldProps}
      label={displayedLabel}
      ref={ref}
      sx={sx}
      slotProps={{
        ...textFieldProps.slotProps,
        formHelperText: {
          variant: "standard",
          "aria-live": "polite",
        },
      }}
    />
  );
});

export default TextField;
